import React from 'react';
import { getStaticProps as getStaticPropsMethod } from '@/bit/pages/pages.create-pages';
import Saam from '@/bit/core/core.scripts.saam';
import { wrapper } from 'store';
import TvClientForm from '@/forms/client/gp/tv';
import { PATH_NAME, URL_SEO } from '@/constants/pages/tv';
import MetaData from '@/bit/core/core.meta-data';

const Tv = ({ seoInfo }) => {
  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Saam/>
      <TvClientForm />
    </>
  );
};
export default Tv;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, '', 2, {
    pathname: PATH_NAME.GP,
    orionAlias: '',
    seoLocation: URL_SEO,
    headerLocation: '/',
    layoutInfo: '',
  });
});
